import _ from 'lodash'
import Vue from 'vue'

const Print = function (dom, options) {
  if (!(this instanceof Print)) {
    return new Print(dom, options)
  }
  this.options = _.defaultsDeep({}, options, {
    noPrint: '.no-print'
  })
  if (_.isString(dom)) {
    this.dom = document.querySelector(dom)
  } else {
    this.dom = dom
  }
  return this.init()
}

Print.prototype = {
  init () {
    let content = '<!DOCTYPE html><html lang="zh">' + this.getHead() + this.getBody() + '</html>'
    return this.writeIframe(content)
  },
  getHead () {
    return document.getElementsByTagName('HEAD')[0].outerHTML
  },
  getBody () {
    let titleStr = ''
    if (this.options.title) {
      titleStr = '<h1>' + this.options.title + '</h1>'
    }
    return '<body style="background: #fff;">' + titleStr + this.dom.outerHTML + '</body>'
  },
  writeIframe (content) {
    let iframe = document.createElement('iframe')
    let f = document.body.appendChild(iframe)
    iframe.id = 'myIframe'
    iframe.style = 'position:absolute;width:0;height:0;top:0;left:0;'
    let w = f.contentWindow || f.contentDocument
    let doc = f.contentDocument || f.contentWindow.document
    doc.open()
    doc.write(content)
    doc.close()
    this.toPrint(w)
    return new Promise(resolve => {
      setTimeout(() => {
        iframe.remove()
        console.log(1111)
        resolve()
      }, 500)
    })
  },
  toPrint (pwindow) {
    pwindow.onload = function () {
      try {
        setTimeout(() => {
          pwindow.focus()
          try {
            if (!pwindow.document.execCommand('print', false, null)) {
              pwindow.print()
            }
          } catch (e) {
            pwindow.print()
          }
          pwindow.close()
        }, 10)
      } catch (err) {
        console.log('err', err)
      }
    }
  }
}

const PrintPlugin = {}
PrintPlugin.install = function (Vue) {
  Vue.prototype.$print = Print
}

export default PrintPlugin

Vue.use(PrintPlugin)
